import { request } from '../utils/httpClient';

export const getOfficerElectionInstructions = (data) => {
  return request({
    url: `/membership/officers-elections/instructions/${data.id}`,
    method: 'GET',
  });
};

export const getOfficerElectionOfficiers = (data) => {
  return request({
    url: `/membership/officers-elections/officers/${data.id}`,
    method: 'GET',
  });
};

export const getOfficerElectionSchedule = (data) => {
  return request({
    url: `/membership/officers-elections/schedules/${data.id}`,
    method: 'GET',
  });
};

export const addOfficierElectionSchedule = (data) => {
  let formId = data.id;
  delete data.id;
  return request({
    url: `/membership/officers-elections/schedules/${formId}`,
    method: 'POST',
    data: data,
  });
};

export const updateOfficierElectionSchedule = (data) => {
  let formId = data.id;
  delete data.id;
  return request({
    url: `/membership/officers-elections/schedules/${formId}`,
    method: 'PATCH',
    data: data,
  });
};

export const deleteOfficerElectionSchedule = (data) => {
  return request({
    url: `/membership/officers-elections/schedules/${data.id}/${data.schedule_id}`,
    method: 'DELETE',
  });
};

export const addOfficierElectionOfficer = (data) => {
  let formId = data.id;
  delete data.id;
  return request({
    url: `/membership/officers-elections/officers/${formId}`,
    method: 'POST',
    data: data,
  });
};

export const updateOfficierElectionOfficer = (data) => {
  let formId = data.id;
  delete data.id;
  return request({
    url: `/membership/officers-elections/officers/${formId}`,
    method: 'PATCH',
    data: data,
  });
};

export const getOfficerElectionSummary = (data) => {
  return request({
    url: `/membership/officers-elections/summary/${data.id}`,
    method: 'GET',
  });
};

export const completeOfficerElection = (data) => {
  return request({
    url: `/membership/officers-elections/complete/${data.id}`,
    method: 'POST',
  });
};

export const updateElectionOfficerAssignee = (data) => {
  let formId = data.id;
  delete data.id;

  return request({
    url: `/membership/officers-elections/assignments/${formId}`,
    method: 'PATCH',
    data: data,
  });
};

export const getSPDElectionInstructions = (data) => {
  return request({
    url: `/membership/spd_election/instructions/${data.id}`,
    method: 'GET',
  });
};

export const getSPDElectionOfficiers = (data) => {
  return request({
    url: `/membership/spd_election/officers/${data.id}`,
    method: 'GET',
  });
};

export const patchSPDElectionOfficiers = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/spd_election/officers/${formId}`,
    method: 'PATCH',
    data: data,
  });
};

export const getSPDElectionAssistants = (data) => {
  return request({
    url: `/membership/spd_election/assistants/${data.id}`,
    method: 'GET',
  });
};

export const patchSPDElectionAssistants = (data) => {
  return request({
    url: `/membership/spd_election/assistants/${data.formId}`,
    method: 'PATCH',
    data: data.patchData,
  });
};

export const getSPDElectionQBE = (data) => {
  return request({
    url: `/membership/spd_election/qbe/${data.id}`,
    method: 'GET',
  });
};

export const patchSPDElectionQBE = (data) => {
  return request({
    url: `/membership/spd_election/qbe/${data.formId}`,
    method: 'PATCH',
    data: data.patchData,
  });
};

export const getSPDElectionSummary = (data) => {
  return request({
    url: `/membership/spd_election/summary/${data.id}`,
    method: 'GET',
  });
};

export const completeSPDElection = (data) => {
  return request({
    url: `/membership/spd_election/complete/${data.id}`,
    method: 'POST',
  });
};

export const getSPDAssistantPositions = () => {
  return request({
    url: `/membership/spd_appointed_positions`,
    method: 'GET',
  });
};

export const resetSPDForm = (data) => {
  return request({
    url: `/membership/spd_election/reset/${data.id}`,
    method: 'PATCH',
  });
};

export const getResourceList = (data) => {
  return request({
    url: `/resources/list`,
    method: 'GET',
    params: {
      page: data.page,
      rowsPerPage: data.rowsPerPage,
      orderBy: data.orderBy,
      order: data.order,
      search: data.search,
    },
  });
};

export const getIntlCommittees = (data) => {
  return request({
    url: `/membership/international/standing_committees`,
    method: 'GET',
  });
};

export const getIntlAppointments = (data) => {
  return request({
    url: `/membership/international/standing_appointments`,
    method: 'GET',
  });
};

export const getIntlInfo = (data) => {
  return request({
    url: `/membership/international/info`,
    method: 'GET',
  });
};

export const getIntlBoard = (data) => {
  return request({
    url: `/membership/international/board_of_directors`,
    method: 'GET',
  });
};
